import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { LayoutDashboard, Landmark, Users, Briefcase, ClipboardList, LineChart, GraduationCap, UserCog, MapPinned, ShieldCheck, MailCheck, PhoneCall } from "lucide-react";
import VisitsPage from "@/pages/shared/VisitsPage";
import SecurityPage from "@/pages/admin/SecurityPage";
import NotificationsPage from "@/pages/admin/NotificationsPage";
import LoanLeadsPage from "@/pages/admin/LoanLeadsPage";
import Overview from "@/pages/admin/Overview";
import BanksPage from "@/pages/admin/BanksPage";
import ExecutivesPage from "@/pages/admin/ExecutivesPage";
import StaffPage from "@/pages/admin/StaffPage";
import LeadsPage from "@/pages/shared/LeadsPage";
import ReportsPage from "@/pages/admin/ReportsPage";
import CoursesPage from "@/pages/admin/CoursesPage";
import ManagersPage from "@/pages/admin/ManagersPage";

const NAV = [
  { to: "/admin", key: "dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/banks", key: "banks", icon: Landmark },
  { to: "/admin/managers", key: "managers", icon: UserCog, label: "Managers" },
  { to: "/admin/executives", key: "executives", icon: Users },
  { to: "/admin/staff", key: "staff", icon: Briefcase },
  { to: "/admin/leads", key: "leads", icon: ClipboardList },
  { to: "/admin/visits", key: "visits", icon: MapPinned },
  { to: "/admin/loan-leads", key: "loan_leads", icon: PhoneCall, label: "Loan Leads" },
  { to: "/admin/reports", key: "reports", icon: LineChart },
  { to: "/admin/courses", key: "courses", icon: GraduationCap },
  { to: "/admin/security", key: "security", icon: ShieldCheck, label: "Security" },
  { to: "/admin/notifications", key: "notifications", icon: MailCheck, label: "Notifications" },
];

export default function AdminDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout title="ADMIN" nav={NAV} testIdPrefix="admin-nav" />}>
        <Route index element={<Overview />} />
        <Route path="banks" element={<BanksPage />} />
        <Route path="managers" element={<ManagersPage />} />
        <Route path="executives" element={<ExecutivesPage />} />
        <Route path="staff" element={<StaffPage />} />
        <Route path="leads" element={<LeadsPage role="admin" />} />
        <Route path="visits" element={<VisitsPage role="admin" />} />
        <Route path="loan-leads" element={<LoanLeadsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="courses" element={<CoursesPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
      </Route>
    </Routes>
  );
}
